import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

const style = {
  container: (theme: Theme): SerializedStyles => css`
    margin: ${theme.mui.spacing(2)}px;
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    padding: 0;
  `,

  step: (theme: Theme): SerializedStyles => css`
    flex: 0 1 ${theme.mui.spacing(8)}px;
    max-width: ${theme.mui.spacing(8)}px;
    height: ${theme.mui.spacing(1)}px;
    background-color: ${theme.mui.palette.primary.light};
    margin-left: ${theme.mui.spacing(1) / 2}px;
    margin-right: ${theme.mui.spacing(1) / 2}px;
  `,

  activeStep: (theme: Theme): SerializedStyles => css`
    background-color: ${theme.mui.palette.primary.main};
  `,

  visuallyHidden: css`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  `,
};

export default style;
